export default __webpack_public_path__ + "static/media/bar-chart.777ad7f2.svg";